/**
 * mystery-gift.js
 * Toegevoegd 15 okt 2026
 *
 * Zet het gratis Mystery Gift-cadeau automatisch in de winkelwagen voor
 * bezoekers die via de popup of de cadeau-mail binnenkomen. Die link ziet er
 * zo uit:
 *
 *   /discount/MYSTERYGIFT?redirect=/collections/all%3Fmg%3D1
 *
 * /discount/MYSTERYGIFT zet de code op de winkelwagen, ?mg=1 laat dit script
 * weten dat de bezoeker recht heeft op het cadeau.
 *
 * Regels:
 *  - Cadeau erbij zodra er minstens één ander product in de winkelwagen zit.
 *  - Cadeau eruit als de winkelwagen verder leeg is (anders betaalt de klant
 *    $24.99 voor alleen het cadeau - de code geldt pas bij een aankoop).
 *  - Haalt de klant het cadeau zelf weg, dan respecteren we dat en zetten we
 *    het niet opnieuw terug.
 *  - Geldt de code niet (al eens gebruikt - één keer per klant), dan halen we
 *    het cadeau weg zodat niemand er ongemerkt voor betaalt.
 *  - Altijd maximaal 1 cadeau.
 *
 * Leunt op Impulse's cart:updated / cart:build events, net als cart-extras.js.
 */
(function () {
  'use strict';

  var GIFT_VARIANT = 54366137844059;
  var CODE = 'MYSTERYGIFT';
  var KEY = 'avinosMysteryGift'; // '1' = recht op cadeau, '2' = toegevoegd, 'nee' = zelf weggehaald

  var ROUTES = (window.theme && theme.routes) || {};
  var CART_JS = ROUTES.cart || '/cart.js';
  var CART_ADD = ROUTES.cartAdd || '/cart/add.js';
  var CART_CHANGE = ROUTES.cartChange || '/cart/change.js';
  var CART_UPDATE = (ROUTES.home || '/').replace(/\/$/, '') + '/cart/update.js';

  function lees() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function zet(v) {
    try {
      if (v === null) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, v);
    } catch (e) {}
    markeerClaim();
  }

  // Binnengekomen via de cadeau-link?
  try {
    var q = new URLSearchParams(window.location.search);
    if (q.get('mg') === '1' && lees() !== '2') zet('1');
  } catch (e) {}

  function alsJson(r) {
    return r.text().then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(alsJson);
  }
  function haalCart() {
    return fetch(CART_JS, { credentials: 'same-origin' }).then(alsJson);
  }
  function herbouw() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function cadeauRegel(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT) return cart.items[i];
    }
    return null;
  }
  function andereItems(cart) {
    return cart.items.filter(function (i) { return i.variant_id !== GIFT_VARIANT; }).length;
  }
  function codeGeweigerd(cart) {
    var codes = cart && cart.discount_codes;
    if (!codes || !codes.length) return false;
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code).toUpperCase() === CODE && codes[i].applicable === false) return true;
    }
    return false;
  }

  var bezig = false;
  function sync() {
    if (bezig) return;
    bezig = true;
    var vrijgave = setTimeout(function () { bezig = false; }, 8000);

    haalCart().then(function (cart) {
      if (!cart || !cart.items) return null;
      var cadeau = cadeauRegel(cart);
      var anders = andereItems(cart);
      var staat = lees();

      // Verder lege winkelwagen: cadeau eruit, recht blijft bestaan.
      if (cadeau && anders === 0) {
        if (staat === '2') zet('1');
        return post(CART_CHANGE, { id: cadeau.key, quantity: 0 }).then(herbouw);
      }

      // Meer dan één cadeau: terug naar één.
      if (cadeau && cadeau.quantity > 1) {
        return post(CART_CHANGE, { id: cadeau.key, quantity: 1 }).then(herbouw);
      }

      // Cadeau zat erin maar is weg terwijl er nog producten zijn: klant heeft het zelf verwijderd.
      if (!cadeau && staat === '2' && anders > 0) {
        zet('nee');
        return null;
      }

      // Recht op cadeau en er staat iets in de winkelwagen: toevoegen.
      if (!cadeau && staat === '1' && anders > 0) {
        return post(CART_UPDATE, { discount: CODE })
          .then(function () { return post(CART_ADD, { items: [{ id: GIFT_VARIANT, quantity: 1 }] }); })
          .then(haalCart)
          .then(function (nieuw) {
            if (!nieuw || !nieuw.items) return;
            var regel = cadeauRegel(nieuw);
            if (regel && codeGeweigerd(nieuw)) {
              // Code geldt niet voor deze klant: niet laten betalen voor het cadeau.
              zet(null);
              return post(CART_CHANGE, { id: regel.key, quantity: 0 });
            }
            if (regel) zet('2');
          })
          .then(herbouw);
      }

      // Cadeau in de winkelwagen terwijl de code geweigerd wordt: eruit.
      if (cadeau && codeGeweigerd(cart)) {
        zet(null);
        return post(CART_CHANGE, { id: cadeau.key, quantity: 0 }).then(herbouw);
      }
      return null;
    })['catch'](function (e) {
      console.warn('[mystery-gift]', e);
    }).then(function () {
      clearTimeout(vrijgave);
      bezig = false;
    });
  }

  var wachttijd = null;
  function syncStraks() {
    // Bezoekers zonder cadeau-link: niets doen, geen extra verzoeken.
    var staat = lees();
    if (staat !== '1' && staat !== '2') return;
    if (wachttijd) clearTimeout(wachttijd);
    wachttijd = setTimeout(sync, 400);
  }

  /*
    Direct na inschrijven in de Klaviyo-popup (toegevoegd 15 okt 2026):
    de klant hoeft niet meer op "Start shopping" te klikken. Zodra het
    formulier is verstuurd zetten we de code op de winkelwagen en - als er
    al iets in zit - het cadeau erbij. Klikt of sluit de klant daarna, dan
    staat alles al klaar.

    GIFT_FORMS = de Klaviyo-formulieren die recht geven op het cadeau.
    Maak je een nieuwe (bijv. seizoens-)versie van de popup, zet het
    formulier-ID er dan bij.
  */
  var GIFT_FORMS = ['W8zFKt'];

  function activeerNaInschrijving() {
    if (lees() !== '2') zet('1');
    // /discount/CODE zet de kortingscookie; redirect naar het kleine cart.js
    // in plaats van de hele homepage.
    fetch((ROUTES.home || '/').replace(/\/$/, '') + '/discount/' + CODE + '?redirect=%2Fcart.js', {
      credentials: 'same-origin'
    })['catch'](function () {}).then(syncStraks);
  }

  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'submit') return;
    if (GIFT_FORMS.indexOf(String(d.formId)) === -1) return;
    activeerNaInschrijving();
  });

  /*
    Cart drawer gaat voor (toegevoegd 15 okt 2026):
    zolang de cart drawer of het menu openstaat, verbergen we het 🎁-bolletje
    (Klaviyo-teaser) en ook de popup zelf, zodat niets over de winkelwagen of
    de checkout-knop heen valt. Gaat de drawer dicht, dan komen ze gewoon
    terug. Impulse zet de class js-drawer-open op <html> zolang een drawer
    openstaat (hetzelfde vangnet als bij de sticky add-to-cart balk).
  */
  /*
    Plus (15 okt 2026):
    - mg-teaser-off: na "No thanks" is het bolletje weg (zie hieronder).
    - has-sticky-atc: op de productpagina zweeft het bolletje boven de
      sticky add-to-cart balk in plaats van eroverheen.
  */
  (function () {
    var css =
      'html.js-drawer-open [class*="kl-teaser-"],' +
      'html.js-drawer-closing [class*="kl-teaser-"],' +
      'html.mg-teaser-off [class*="kl-teaser-"],' +
      'html.js-drawer-open [data-kl-scroll-locking-modal]' +
      // Bewust visibility en geen display:none. Met display:none speelt de
      // animatie van Klaviyo niet af en blijft er na het sluiten een
      // onzichtbare laag over de pagina liggen (alles onklikbaar).
      '{visibility:hidden !important;pointer-events:none !important}' +
      'body.has-sticky-atc [class*="kl-teaser-"]' +
      '{bottom:90px !important;transition:bottom .22s ease}';
    try {
      var s = document.createElement('style');
      s.setAttribute('data-mystery-gift', 'drawer');
      s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
    } catch (e) {}
  })();

  /*
    "No thanks", de homepage-strook en #mystery-gift (15 okt 2026)

    - Klikt iemand op "No thanks", dan verdwijnt het 🎁-bolletje. Het kruisje
      of naast de popup tikken laat het bolletje wel staan (die mensen wilden
      vaak alleen de popup even weg). Zodra de popup later weer opengaat,
      begint het opnieuw: dan beslist de nieuwe keuze.
    - Alles met data-mystery-gift-open of een link naar #mystery-gift opent
      de popup, ook na "No thanks". Zo werkt de strook op de homepage
      (sections/mystery-gift-strip.liquid). Een URL die eindigt op
      #mystery-gift opent hem bij het laden.
    - Heeft de bezoeker het cadeau al, dan krijgt <html> de class mg-claimed
      en toont de strook "Your mystery gift is unlocked".

    OPEN_FORM = het formulier dat de link opent. Zet hier de seizoensversie
    neer zolang die loopt.
  */
  var OPEN_FORM = 'W8zFKt';
  var TEASER_KEY = 'avinosGiftTeaser'; // 'uit' = bolletje verborgen na "No thanks"

  function htmlClass(naam, aan) {
    try { document.documentElement.classList.toggle(naam, !!aan); } catch (e) {}
  }
  function teaserUit(uit) {
    try {
      if (uit) localStorage.setItem(TEASER_KEY, 'uit');
      else localStorage.removeItem(TEASER_KEY);
    } catch (e) {}
    htmlClass('mg-teaser-off', uit);
  }
  function markeerClaim() {
    var staat = lees();
    htmlClass('mg-claimed', staat === '1' || staat === '2');
  }

  function openGiftForm() {
    teaserUit(false);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', OPEN_FORM]);
  }

  try { if (localStorage.getItem(TEASER_KEY) === 'uit') htmlClass('mg-teaser-off', true); } catch (e) {}

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-mystery-gift-open], a[href="#mystery-gift"], a[href$="/#mystery-gift"]');
    if (opener) {
      e.preventDefault();
      if (lees() === '1' || lees() === '2') return; // heeft het cadeau al
      openGiftForm();
      return;
    }

    var knop = t.closest('[data-kl-scroll-locking-modal] button');
    if (knop && /^\s*no thanks\s*$/i.test(knop.textContent || '')) teaserUit(true);
  }, true);

  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'open') return;
    if (GIFT_FORMS.indexOf(String(d.formId)) === -1) return;
    teaserUit(false);
  });

  if (window.location.hash === '#mystery-gift' && lees() !== '1' && lees() !== '2') openGiftForm();

  function init() {
    markeerClaim();
    document.addEventListener('cart:updated', syncStraks);
    document.addEventListener('ajaxProduct:added', syncStraks);
    document.addEventListener('drawerOpen', syncStraks);
    var staat = lees();
    if (staat === '1' || staat === '2') sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
